import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AdminMatches() {
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [form, setForm] = useState({ team_a_id: "", team_b_id: "", ground: "", match_date: "", match_time: "" });
  const load = async () => { setTeams((await api.get("/teams")).data); setMatches((await api.get("/matches")).data); };
  useEffect(() => { load(); }, []);
  const create = async () => {
    if (!form.team_a_id || !form.team_b_id || !form.ground || !form.match_date) return toast.error("Fill fields");
    try { await api.post("/admin/matches", form); toast.success("Match created"); setForm({ team_a_id: "", team_b_id: "", ground: "", match_date: "", match_time: "" }); load(); }
    catch { toast.error("Failed"); }
  };
  const del = async (id) => { await api.delete(`/admin/matches/${id}`); load(); };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Fixtures</div>
      <h1 className="font-display text-4xl mt-2">Match Management</h1>
      <div className="mt-6 p-6 bg-[#0B132B] border border-white/10 rounded grid md:grid-cols-6 gap-3">
        <select value={form.team_a_id} onChange={(e)=>setForm({...form, team_a_id: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="match-team-a">
          <option value="" className="bg-[#0B132B]">Team A</option>
          {teams.map((t)=><option key={t.id} value={t.id} className="bg-[#0B132B]">{t.name}</option>)}
        </select>
        <select value={form.team_b_id} onChange={(e)=>setForm({...form, team_b_id: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="match-team-b">
          <option value="" className="bg-[#0B132B]">Team B</option>
          {teams.map((t)=><option key={t.id} value={t.id} className="bg-[#0B132B]">{t.name}</option>)}
        </select>
        <input placeholder="Ground" value={form.ground} onChange={(e)=>setForm({...form, ground: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" />
        <input type="date" value={form.match_date} onChange={(e)=>setForm({...form, match_date: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" />
        <input type="time" value={form.match_time} onChange={(e)=>setForm({...form, match_time: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" />
        <button onClick={create} data-testid="create-match" className="py-2 bg-[#39FF14] text-black font-bold uppercase tracking-widest text-xs">Create Match</button>
      </div>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {matches.map((m) => (
          <div key={m.id} className="p-5 bg-[#0B132B] border border-white/10 rounded">
            <div className="flex items-center justify-between">
              <div className="text-xs uppercase text-[#FFD700] tracking-widest">{m.match_date} • {m.match_time}</div>
              <button onClick={()=>del(m.id)} className="text-[#FF2442] p-1"><Trash2 size={14}/></button>
            </div>
            <div className="mt-3 flex items-center justify-between">
              <div className="font-display text-2xl">{m.team_a?.name || "TBD"}</div>
              <div className="text-white/50 text-xs">VS</div>
              <div className="font-display text-2xl text-right">{m.team_b?.name || "TBD"}</div>
            </div>
            <div className="mt-3 text-xs text-white/50">📍 {m.ground}</div>
          </div>
        ))}
        {matches.length === 0 && <div className="col-span-full text-white/40 text-sm">No fixtures yet.</div>}
      </div>
      <div className="mt-8 p-6 border border-dashed border-white/10 text-white/40 text-sm">🏏 Live scoring module coming soon</div>
    </div>
  );
}
